import { render } from "./TextInputEditor.vue?vue&type=template&id=444ce93f&scoped=true&ts=true"
import script from "./TextInputEditor.vue?vue&type=script&lang=ts"
export * from "./TextInputEditor.vue?vue&type=script&lang=ts"

import "./TextInputEditor.vue?vue&type=style&index=0&id=444ce93f&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-444ce93f"]])

export default __exports__